import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Add, Remove } from '@material-ui/icons';
import classnames from 'classnames';

import { anchorIsNakedNewsLive } from '../../utils/helpers';

import AnchorStats from './AnchorStats';
import BioVideo from './BioVideo';
import styles from './css/Bio.module.css';


const MAX_STRING_LENGTH = 700;


function Bio(props) {
  const {
    anchor,
    user,
    isImageLayout,
    authenticated,
    promoVideo,
    promoThumbnail,
    isPastAnchor,
  } = props;
  const [readMore, setReadMore] = useState(false);
  const isNakedNewsLive = anchorIsNakedNewsLive(anchor?.id);
  const [string, setString] = useState('');
  const [truncatedString, setTruncatedString] = useState('');

  const truncate = (str) => {
    if (str.length > MAX_STRING_LENGTH) {
      return `${str.slice(0, MAX_STRING_LENGTH)}...`;
    }

    return str;
  };

  useEffect(() => {
    const { bio } = anchor.biography;
    setString(bio);
    setTruncatedString(truncate(bio));
  }, []);

  const toggleReadMore = useCallback(() => {
    setReadMore(!readMore);
  }, [readMore, setReadMore]);

  const readMoreButton = useMemo(() => {
    const desktopReadMoreElement = readMore ? 'less' : 'more...';
    if (isNakedNewsLive || (string.length < MAX_STRING_LENGTH)) {
      return null;
    }

    return (
      <React.Fragment>
        <button
          className={
            classnames(
              styles.textLeft,
              styles.readMoreToggler,
              styles.desktop
            )
          }
          onClick={toggleReadMore}
        >
          Read {desktopReadMoreElement}
        </button>
      </React.Fragment>
    );
  }, [isNakedNewsLive, readMore, toggleReadMore, string]);

  const subscriptionPurchaseLink = useMemo(() => {
    const shouldShowLink = !authenticated && !isNakedNewsLive;
    if (!shouldShowLink) {
      return null;
    }

    return (
      <a
        className={styles.stripShowLink}
        href="/account/purchase"
      >
        Watch {anchor.name}&apos;s Full Strip Show
        inside Naked News
      </a>
    );
  }, [anchor.name, authenticated, isNakedNewsLive]);

  const mobileReadMoreElement = readMore ? <Remove /> : <Add />;
  const bioData = useMemo(() => {
    if (readMore) {
      return string;
    }

    return truncatedString;
  }, [readMore, string, truncatedString]);

  return (
    <div className="masthead">
      <div className="container">
        <div className={styles.anchorPedigree}>
          <div className={styles.row}>
            <div
              className={classnames({ [styles.bioContainerVideoPlayer]: !isNakedNewsLive })}
            >
              <div className={styles.bioColumnLeft}>
                <div className={styles.anchorPedigreeMain}>
                  <div className={styles.anchorPedigreeBio}>
                    <div className={styles.biographyText}>
                      <p className={styles.biographyMain}>
                        <h2 className={styles.bioHeader}><strong>Bio: </strong></h2>
                        <span
                          className={styles.bioContent}
                          dangerouslySetInnerHTML={{ __html: bioData }}
                        />
                        <button
                          className={
                            classnames(
                              styles.textLeft,
                              styles.readMoreToggler,
                              styles.mobile
                            )
                          }
                          onClick={toggleReadMore}
                        >
                          {mobileReadMoreElement}
                        </button>
                      </p>
                      {readMoreButton}
                    </div>
                    {subscriptionPurchaseLink}
                  </div>
                </div>
              </div>
              <BioVideo
                anchor={anchor}
                promoThumbnail={promoThumbnail}
                promoVideo={promoVideo}
                user={user}
              />
              <AnchorStats
                anchor={anchor}
                isImageLayout={isImageLayout}
                isNakedNewsLive={isNakedNewsLive}
                isPastAnchor={isPastAnchor}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Bio;

